module.exports = __webpack_public_path__ + "static/media/luckyThree-2.6c7bc9f8.png";